/**
 * Utility functions for variant option handling
 */

/**
 * Cleans a product title by removing specified words
 * @param {string} title - The title to clean
 * @param {Array<string>} wordsToRemove - Array of words to remove from the title
 * @returns {string} - The cleaned title
 */
function cleanProductTitle(title, wordsToRemove = []) {
  if (!title || typeof title !== 'string') {
    return '';
  }

  let cleanedTitle = title;

  wordsToRemove.forEach((word) => {
    const regex = new RegExp(word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi');
    cleanedTitle = cleanedTitle.replace(regex, '');
  });

  return cleanedTitle.replace(/\s+/g, ' ').trim();
}

/**
 * Cleans color-specific product titles (Meriwool, Wool, etc.)
 * Maintains backward compatibility with existing cleanColorTitleJS function
 * @param {string} title - The color product title to clean
 * @returns {string} - The cleaned color title
 */
function cleanColorTitle(title) {
  // Extract text after "-" if it exists
  let cleanedTitle = title.includes('-')
    ? title.split('-').slice(1).join('-').trim()
    : title;

  // Remove content within parentheses (including the parentheses)
  cleanedTitle = cleanedTitle.replace(/\s*\([^)]*\)/g, '').trim();

  return cleanedTitle;
}

/**
 * Finds a product option by searching through multiple localized names
 * @param {Array} options - Array of product options (product.options_with_values)
 * @param {Array<string>} searchNames - Array of possible option names (lowercase)
 * @returns {Object|null} - The matching option or null
 */
function findOptionByNames(options, searchNames) {
  if (!options || !Array.isArray(options) || !searchNames || !Array.isArray(searchNames)) {
    return null;
  }

  for (const option of options) {
    const optionNameLower = option.name.toLowerCase();

    for (const searchName of searchNames) {
      if (optionNameLower === searchName.trim().toLowerCase()) {
        return option;
      }
    }
  }

  return null;
}

// Backward compatibility alias
var cleanColorTitleJS = cleanColorTitle;
